<template>
  <!--  eslint-disable max-len  -->
  <section id="download">
    <div class="row">
      <div class="title col-md-8 d-flex align-items-center justify-content-start ml-auto">
        <h1 class="h5">H'S VIBE 齊來卡</h1>
      </div>
      <div class="col-12">
        <div class="desc mt-30 p-20">
          <a
            href="https://itunes.apple.com/us/app/hs-vibe-%E9%BD%8A%E4%BE%86%E5%8D%A1/id1449947800?mt=8&ign-mpt=uo%3D2"
            target="_blank"
            class="btn btn-primary rounded-pill mr-10"
          >前往Apple Store</a>
          <a
            href="https://play.google.com/store/apps/details?id=com.hsvibe"
            target="_blank"
            class="btn btn-primary rounded-pill"
          >前往Google Play商店</a>
        </div>
        <div class="desc p-20">
        <h4>H'S VIBE 齊來卡 顯示「此應用程式與您的裝置不相容。」</h4>
              <p>此問題為裝置上的Google Play商店App 發生問題所產生
              Google 建議清除您裝置上Google Play商店的快取資料。請按照以下步驟進行操作：</p>
              <ul style="font-weight: 100;line-height: 30px;">
              <li>進入「設定」</li>
              <li>選擇「應用程式管理」>全部</li>
              <li>選擇Google Play商店清除快取</li>
              </ul>
              <ul style="font-weight: 100;line-height: 30px;">
              或者，您也可以重新安裝Google Play商店。請按照以下步驟進行操作：
              <li>進入「設定」</li>
              <li>選擇程式和通知</li>
              <li>選擇「查看全部程式」 >Google Play商店</li>
              <li>點擊右上角三圓點圖示 > 解除安裝更新</li>
              </ul>
              如仍然無法解決版本不相容的問題, 可直接下載apk安裝app
              <a href="/app/hsvibe_v3.0.5.apk" class="btn btn-primary rounded-pill mr-10" >下載 Android v3.0.5 版本</a>
              <p class="mt-20"><img src="/app/demo.jpg" width="300" /></p>
        </div>

      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: 'download',
  mounted() {
    console.log(navigator.userAgent);
    // alert(navigator.userAgent);
    if (navigator.userAgent.indexOf('iPhone') >= 0) {
      window.location.href = 'https://itunes.apple.com/us/app/hs-vibe-%E9%BD%8A%E4%BE%86%E5%8D%A1/id1449947800?mt=8&ign-mpt=uo%3D2';
    }
  },
};
</script>
<style lang="scss" scoped>
#Upgrade {
  overflow: hidden;
  padding: 20px 0 100px;
  p,
  li {
    letter-spacing: 1.5px;
  }
  .title {
    border-bottom: 2px solid $primary-light;
  }
  .desc {
    background: linear-gradient(to right, white 30%, $secondary-white 120%);
    p {
      color: $secondary;
    }
    ul {
      list-style: disc;
    }
  }
}
</style>
